import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
// Actualizar el import de Navbar
import NavbarUsuario from './NavbarUsuario';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { endpoints } from '../config/apiConfig';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const ListadoEstudiantes = () => {
  const navigate = useNavigate();
  const [estudiantes, setEstudiantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(1);
  const [estudiantesSinRevision, setEstudiantesSinRevision] = useState([]);
  const [nombrePrograma, setNombrePrograma] = useState('');
  const [globalFilter, setGlobalFilter] = useState('');

  const tabs = [
    { id: 1, label: "Revisado" },
    { id: 0, label: "Sin Revisión" }
 
  ];
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userRole = localStorage.getItem('userRole');
        const token = localStorage.getItem('token');
        const programaId = localStorage.getItem('programaId');

        if (!userRole || userRole !== '2' || !token) {
          navigate('/loginUsuario');
          return;
        }

        // Obtener información del usuario y programa
        const userInfoResponse = await fetch(endpoints.userInfo, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          }
        });

        if (userInfoResponse.ok) {
          const userData = await userInfoResponse.json();
          if (userData.ok && userData.user) {
            setNombrePrograma(userData.user.programa || 'Programa no especificado');
          }
        }

        // Resto del código para obtener estudiantes
        const periodoActivo = '2';

        if (activeTab === 0) {
          const responseSinRevision = await fetch(
            endpoints.estudiantesSinRevision(programaId),
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json'
              }
            }
          );

          if (!responseSinRevision.ok) throw new Error('Error al obtener estudiantes sin revisión');
          
          const dataSinRevision = await responseSinRevision.json(); // 
          
          if (dataSinRevision.success && dataSinRevision.data?.estudiantes) {
            const estudiantesConIndice = dataSinRevision.data.estudiantes.map((est, index) => ({
              indice: index + 1,
              cedula: est.documento,
              nombre: est.estudiante,
              email: est.email_institucional,
              programa: est.programa,
              estado: null
            }));
            setEstudiantesSinRevision(estudiantesConIndice);
          }
        }
  
        // Fetch todos los estudiantes (para la pestaña "Revisado")
        if (activeTab === 1) {
          const response = await fetch(endpoints.estudiantesPorPrograma(programaId), {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Accept': 'application/json'
            }
          });
  
          if (!response.ok) throw new Error('Error al obtener el listado de estudiantes');
          
          const responseData = await response.json();
          
          if (responseData.success && Array.isArray(responseData.data)) {
            const uniqueEstudiantes = Array.from(
              new Map(responseData.data.map(item => [item.cedula, item])).values()
            );
            
            const estudiantesConIndice = uniqueEstudiantes.map((est, index) => ({
              ...est,
              indice: index + 1
            }));
            
            setEstudiantes(estudiantesConIndice);
          }
        }
      } catch (error) {
        console.error('Error:', error);
        setError('Error al cargar el listado de estudiantes');
      } finally {
        setLoading(false);
      }
    };
  
    setLoading(true);
    fetchData();
  }, [navigate, activeTab]); // Eliminar la llave y punto y coma extra que estaba aquí

  const estadoTemplate = (rowData) => {
    let severity = 'warning';
    let value = 'Pendiente';

    if (rowData.estado === 1) {
      severity = 'success';
      value = 'Aprobado';
    } else if (rowData.estado === 0) {
      severity = 'danger';
      value = 'Rechazado';
    }

    return <Tag severity={severity} value={value} />;
  };

  const fechaTemplate = (rowData) => {
    return rowData.fecha_revision 
      ? new Date(rowData.fecha_revision).toLocaleDateString()
      : '-';
  };

  const getEstudiantesFiltrados = () => {
    if (activeTab === 0) {
      return estudiantesSinRevision;
    } else {
      return estudiantes.filter(est => est.estado === 1 || est.estado === 0);
    }
  };

  const handleDownloadPDF = async (documento) => {
    try {
      const token = localStorage.getItem('token');
      const periodoActivo = '2'; // Mismo periodo que usamos en el fetch de datos

      const response = await fetch(
        `https://intraweb.udi.edu.co/rev_mat_back/public/api/generar-pdf/${documento}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) throw new Error('Error al descargar el PDF');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `matricula_${documento}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error:', error);
      setError('Error al descargar el PDF. Por favor, intente nuevamente.');
    }
  };
  const archivoTemplate = (rowData) => {
    return rowData.estado !== null ? (
      <Button
        icon="pi pi-file-pdf"
        className="p-button-rounded p-button-text p-button-info"
        onClick={() => handleDownloadPDF(rowData.cedula)}
        tooltip="Descargar PDF"
        tooltipOptions={{ position: 'top' }}
      />
    ) : null;
  };
  return (
    <>
      <NavbarUsuario />
      <div className="bg-gray-100 min-h-screen p-8">
        <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            Listado de Estudiantes {`de ${nombrePrograma}`}
          </h1>

          {error && (
            <div className="p-4 mb-4 text-red-700 bg-red-100 rounded">
              {error}
            </div>
          )}

          <div className="flex justify-between items-center mb-6">
            <div className="w-64 flex space-x-2 bg-gray-200 p-1 rounded-xl">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className="relative flex-1 px-4 py-2 text-center font-medium focus:outline-none"
                >
                  {activeTab === tab.id && (
                    <motion.div
                      layoutId="underline"
                      className="absolute inset-0 bg-white rounded-xl shadow-md"
                      transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    />
                  )}
                  <span className="relative z-10">{tab.label}</span>
                </button>
              ))}
            </div>

            <span className="p-input-icon-left">
              <InputText
                value={globalFilter}
                onChange={(e) => setGlobalFilter(e.target.value)}
                placeholder="Buscar..."
                className="p-inputtext-sm border focus:ring-2 focus:ring-offset-2 focus:ring-stone-800"
              />
            </span>
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              <DataTable 
                value={getEstudiantesFiltrados()}
                loading={loading}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25, 50]}
                emptyMessage="No se encontraron estudiantes"
                className="p-datatable-sm p-datatable-gridlines p-datatable-bordered"
                stripedRows
                showGridlines
                globalFilter={globalFilter}
                filterDelay={300}
              >
                <Column field="indice" header="#" sortable style={{ width: '5%', border: '1px solid #ccc' }}/>
                <Column field="cedula" header="Documento" sortable style={{ width: activeTab === 0 ? '12%' : '10%', border: '1px solid #ccc' }}/>
                <Column field="nombre" header="Estudiante" sortable style={{ width: activeTab === 0 ? '25%' : '20%', border: '1px solid #ccc' }}/>
                <Column field="email" header="Email Institucional" sortable style={{ width: activeTab === 0 ? '20%' : '15%', border: '1px solid #ccc' }}/>
                {activeTab === 1 && (
                  <Column field="observacion" header="Observaciones" sortable style={{ width: '30%', border: '1px solid #ccc' }}/>
                )}
                <Column field="estado" header="Estado" body={estadoTemplate} sortable style={{ width: '10%', border: '1px solid #ccc' }}/>
                {activeTab === 1 && (
                  <Column header="Archivo" body={archivoTemplate} style={{ width: '3%', border: '1px solid #ccc' }}/>
                )}
              </DataTable>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </>
  );
};

export default ListadoEstudiantes;